<div class="feeding-record global-table-wrapper">
    <div class="header">
        <h3>Feeding</h3>
        <button
            *appHasRole="['Admin', 'Farm manager']"
            class="btn-action-primary"
            (click)="openForm()"
        >
            Record Feeding
        </button>
    </div>

    <app-search-filter
        [config]="filterConfig"
        [externalForm]="filterForm"
        (filter)="onFilter($event)"
        (clear)="onFilterCleared()"
    ></app-search-filter>

    <p-table
        [value]="data"
        responsiveLayout="scroll"
        [loading]="loading"
        [paginator]="true"
        [lazy]="true"
        [rows]="pageSize"
        [totalRecords]="totalRecords"
        (onLazyLoad)="onPageChange($event)"
    >
        <ng-template pTemplate="header">
            <tr>
                <th>Time</th>
                <th>House Name</th>
                <th>Quantity (kg)</th>
                <th></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
            <tr>
                <td [attr.title]="item.time">
                    {{ item.time | date: 'yyyy-MM-dd HH:mm' }}
                </td>
                <td>{{ item.name }}</td>
                <td>{{ item.quantity }}</td>
                <td>
                    <a
                        (click)="editFeeding(item)"
                        pTooltip="Edit"
                        tooltipPosition="top"
                        class="table-action-icon"
                        ><i class="far fa-edit"></i
                    ></a>
                    <a
                        (click)="deleteFeeding(item)"
                        pTooltip="Delete"
                        tooltipPosition="top"
                        class="table-action-icon"
                    >
                        <i class="fas fa-trash-alt"></i>
                    </a>
                </td>
            </tr>
        </ng-template>
    </p-table>
    <p-dialog
        [(visible)]="showForm"
        modal="true"
        focusOnShow="false"
        [style]="{width: '800px'}"
        [closable]="false"
        [baseZIndex]="200000"
        [appendTo]="'body'"
    >
        <div class="text-left close-popup-pdialog" (click)="closeForm()">
            <span class="fas fa-chevron-left"></span> Back
        </div>
        <ng-template pTemplate="content">
            <form [formGroup]="form" (ngSubmit)="submit()" class="record-form">
                <div class="form-group">
                    <label>Date & Time</label>
                    <input
                        type="datetime-local"
                        class="form-control"
                        formControlName="datetime"
                        required
                    />
                    <div
                        class="invalid"
                        *ngIf="
                            form.get('datetime')?.touched &&
                            form.get('datetime')?.invalid
                        "
                    >
                        Required
                    </div>
                </div>

                <div class="form-group">
                    <label>House</label>
                    <select
                        class="form-select"
                        formControlName="houseId"
                        required
                    >
                        <option [ngValue]="null">Select house</option>
                        <option *ngFor="let h of houseOptions" [ngValue]="h.id">
                            {{ h.name }}
                        </option>
                    </select>
                    <div
                        class="invalid text-red"
                        *ngIf="
                            form.get('houseId')?.touched &&
                            form.get('houseId')?.invalid
                        "
                    >
                        Required
                    </div>
                </div>

                <div class="form-group">
                    <label>Quantity (kg)</label>
                    <input
                        type="number"
                        step="0.01"
                        min="0"
                        class="form-control"
                        formControlName="quantity"
                        required
                    />
                    <div
                        class="invalid"
                        *ngIf="
                            form.get('quantity')?.touched &&
                            form.get('quantity')?.invalid
                        "
                    >
                        Enter a positive number
                    </div>
                </div>

                <div class="form-actions text-center">
                    <button type="submit" class="btn-action-primary">
                        {{ editingNumericId ? 'Update' : 'Add' }}
                    </button>
                </div>
            </form>
        </ng-template>
    </p-dialog>

    <!-- Delete Confirmation Dialog -->
    <p-dialog
        [(visible)]="showDeleteConfirm"
        modal="true"
        [style]="{width: '420px'}"
        [closable]="true"
        [baseZIndex]="200001"
        [appendTo]="'body'"
        [draggable]="false"
    >
        <ng-template pTemplate="header">
            <span>Confirm Deletion</span>
        </ng-template>
        <ng-template pTemplate="content">
            <p>
                Are you sure you want to delete this feeding record? This action
                cannot be undone.
            </p>
            <div class="dialog-actions text-center">
                <button class="close-btn-secondary" (click)="cancelDelete()">
                    Cancel
                </button>
                <button class="btn-action-delete" (click)="confirmDelete()">
                    Delete
                </button>
            </div>
        </ng-template>
    </p-dialog>
</div>
